import React, { useState } from 'react';
import EnhancedSEO from '../../Components/SEO/EnhancedSEO';


const CommunityGuidelinesPage = () => {
  const [expandedSection, setExpandedSection] = useState('overview');
  const [showSection, setShowSection] = useState(false); // Flag to control team section visibility
  

  const handleAccordionToggle = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 16px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1.5,
    color: '#212121'
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, #388e3c 0%, #2e7d32 100%)',
    color: 'white',
    padding: '32px',
    borderRadius: '8px',
    marginBottom: '32px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  };

  const paperStyle = {
    backgroundColor: '#fff',
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
  };

  const accordionStyle = {
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '8px',
    overflow: 'hidden'
  };

  const accordionHeaderStyle = {
    padding: '16px',
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'background-color 0.2s'
  };

  const accordionContentStyle = {
    padding: '24px',
    borderTop: '1px solid #e0e0e0'
  };

  const chipStyle = {
    display: 'inline-block',
    padding: '6px 12px',
    margin: '4px',
    borderRadius: '16px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const cardStyle = {
    backgroundColor: '#f5f5f5',
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e0e0e0'
  };

  const alertStyle = {
    padding: '16px',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e8f5e8',
    backgroundColor: '#e8f5e8',
    color: '#388e3c'
  };

  const warningAlertStyle = {
    ...alertStyle,
    border: '1px solid #fff3e0',
    backgroundColor: '#fff3e0',
    color: '#f57c00'
  };

  const errorAlertStyle = {
    ...alertStyle,
    border: '1px solid #ffebee',
    backgroundColor: '#ffebee',
    color: '#d32f2f'
  };

  const buttonStyle = {
    padding: '12px 24px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    margin: '4px',
    transition: 'all 0.2s'
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#388e3c',
    color: 'white'
  };

  const outlinedButtonStyle = {
    ...buttonStyle,
    backgroundColor: 'transparent',
    color: '#388e3c',
    border: '1px solid #388e3c'
  };

  const sections = [
    {
      id: 'overview',
      title: 'Community Vision & Values',
      icon: '🌟',
      color: '#388e3c',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Revfer is built on trust, authenticity, and community support. Our guidelines ensure everyone can participate in creating a valuable resource for discovering and evaluating businesses.
          </p>
          
          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>
              Our Community Mission
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              To create the most trusted business discovery platform through authentic reviews, 
              verified connections, and collaborative community verification.
            </p>
          </div>

          <h3 style={{ marginTop: '24px', marginBottom: '16px', color: '#388e3c' }}>
            Core Community Values:
          </h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px', marginTop: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>🔒</span>
                <h4 style={{ margin: 0 }}>Trust & Authenticity</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Honest reviews based on real experiences</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>🤝</span>
                <h4 style={{ margin: 0 }}>Respect & Kindness</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Treating all community members with dignity</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#f3e5f5', color: '#7b1fa2' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>🎯</span>
                <h4 style={{ margin: 0 }}>Helpfulness</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Providing valuable insights for others</p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '20px', marginRight: '8px' }}>⚡</span>
                <h4 style={{ margin: 0 }}>Constructive Engagement</h4>
              </div>
              <p style={{ margin: 0, fontSize: '14px' }}>Building up businesses and our community</p>
            </div>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Guidelines Evolution
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              These guidelines evolve with our community. We welcome feedback and regularly update 
              them to address new situations and maintain a positive environment for everyone.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'authentic-reviews',
      title: 'Writing Authentic Reviews',
      icon: '⭐',
      color: '#1976d2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Authentic reviews are the foundation of our community. Here's how to write reviews that help others make informed decisions:
          </p>

          <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
            <h4 style={{ marginBottom: '12px' }}>✅ What Makes a Great Review</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Personal Experience:</strong> Based on your actual interaction with the business</li>
              <li><strong>Specific Details:</strong> Include relevant specifics about products, services, or experiences</li>
              <li><strong>Balanced Perspective:</strong> Mention both positives and areas for improvement</li>
              <li><strong>Recent & Relevant:</strong> Reflect current business conditions when possible</li>
              <li><strong>Helpful Context:</strong> Explain circumstances that might affect others' experiences</li>
              <li><strong>Constructive Tone:</strong> Professional and respectful, even when critical</li>
            </ul>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
            <h4 style={{ marginBottom: '12px' }}>❌ Review Violations</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Fake Reviews:</strong> Reviews for businesses you haven't actually used</li>
              <li><strong>Revenge Reviews:</strong> Reviews motivated by personal disputes unrelated to business service</li>
              <li><strong>Promotional Content:</strong> Reviews that primarily advertise your own business</li>
              <li><strong>Discrimination:</strong> Reviews targeting protected characteristics</li>
              <li><strong>Privacy Violations:</strong> Sharing private information about employees or customers</li>
              <li><strong>Irrelevant Content:</strong> Content unrelated to the business experience</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>AI-Assisted Review Writing</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Use AI assistance to help articulate your thoughts more clearly</li>
              <li>Always review and edit AI-generated content before publishing</li>
              <li>Ensure the final review accurately reflects your personal experience</li>
              <li>Don't use AI to fabricate experiences you didn't have</li>
              <li>AI should enhance your voice, not replace your authentic perspective</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Rating Guidelines</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>5 Stars:</strong> Exceptional experience that exceeded expectations</li>
              <li><strong>4 Stars:</strong> Very good experience with minor areas for improvement</li>
              <li><strong>3 Stars:</strong> Good experience that met basic expectations</li>
              <li><strong>2 Stars:</strong> Below average experience with significant issues</li>
              <li><strong>1 Star:</strong> Poor experience with major problems</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Review Updates & Edits
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              You can update your reviews if your experience changes or if you notice errors. 
              Updated reviews help maintain accuracy and show businesses' improvement over time.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'trust-network',
      title: 'Building Trust Networks',
      icon: '🔗',
      color: '#7b1fa2',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Trust networks are what make Revfer unique. Here's how to build and maintain meaningful connections:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Making Authentic Connections</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Connect with people you know personally or professionally</li>
              <li>Build relationships with local community members</li>
              <li>Connect with trusted business owners and service providers</li>
              <li>Focus on quality connections over quantity</li>
              <li>Verify connections represent real relationships</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Trust Chain Participation</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Participate honestly in verification activities</li>
              <li>Only verify information you can personally confirm</li>
              <li>Report suspicious verification requests</li>
              <li>Understand how your verification contributes to community trust</li>
              <li>Take verification responsibilities seriously</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Network Integrity</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Don't create fake connections or profiles</li>
              <li>Don't participate in coordinated manipulation schemes</li>
              <li>Report network abuse when you see it</li>
              <li>Maintain the authenticity of your connections</li>
              <li>Use network influence responsibly</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Network Abuse Consequences
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Attempts to manipulate trust networks through fake connections, coordinated reviews, 
              or fraudulent verification can result in permanent account suspension and legal action.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'business-interaction',
      title: 'Business Interactions & Responses',
      icon: '🏢',
      color: '#f57c00',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Guidelines for healthy interactions between customers and businesses on our platform:
          </p>

          <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
            <h4 style={{ marginBottom: '12px' }}>For Customers & Reviewers</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Give businesses reasonable opportunity to address issues before reviewing</li>
              <li>Update reviews if businesses resolve problems satisfactorily</li>
              <li>Be open to business responses and clarifications</li>
              <li>Ask questions in Q&A sections for quick clarifications</li>
              <li>Respect business policies and procedures</li>
              <li>Report inappropriate business behavior to our team</li>
            </ul>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
            <h4 style={{ marginBottom: '12px' }}>For Business Owners</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Respond professionally and constructively to all reviews</li>
              <li>Address legitimate concerns without being defensive</li>
              <li>Thank customers for both positive and constructive feedback</li>
              <li>Don't ask customers to remove or modify reviews</li>
              <li>Don't offer incentives for positive reviews</li>
              <li>Keep business information accurate and up-to-date</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Professional Communication</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Use respectful, professional language in all interactions</li>
              <li>Focus on facts and solutions rather than emotions</li>
              <li>Respect privacy - don't share personal information publicly</li>
              <li>Address the issue, not the person</li>
              <li>Seek resolution rather than winning arguments</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#d32f2f' }}>Prohibited Business Practices</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Creating fake customer accounts to leave positive reviews</li>
              <li>Asking friends/family to leave reviews without genuine experiences</li>
              <li>Offering payments, discounts, or freebies for reviews</li>
              <li>Threatening legal action against negative reviewers</li>
              <li>Retaliating against customers who leave honest negative reviews</li>
              <li>Impersonating competitors or leaving negative reviews about them</li>
            </ul>
          </div>

          <div style={errorAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Review Manipulation Detection
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              We use advanced algorithms and community reporting to detect review manipulation. 
              Businesses caught manipulating reviews face immediate account suspension and potential legal action.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'content-standards',
      title: 'Content & Communication Standards',
      icon: '💬',
      color: '#e65100',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            All content on Revfer should be helpful, respectful, and appropriate for our diverse community:
          </p>

          <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
            <h4 style={{ marginBottom: '12px' }}>Encouraged Content</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Detailed, helpful reviews with specific examples</li>
              <li>High-quality photos that showcase businesses accurately</li>
              <li>Constructive Q&A participation</li>
              <li>Helpful tips and recommendations for other users</li>
              <li>Positive recognition for exceptional service</li>
              <li>Educational content about local businesses and services</li>
            </ul>
          </div>

          <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
            <h4 style={{ marginBottom: '12px' }}>Prohibited Content</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Hate Speech:</strong> Content targeting people based on protected characteristics</li>
              <li><strong>Harassment:</strong> Bullying, threats, or intimidation of any kind</li>
              <li><strong>Spam:</strong> Repetitive, irrelevant, or promotional content</li>
              <li><strong>Graphic Content:</strong> Violent, sexual, or disturbing imagery</li>
              <li><strong>Privacy Violations:</strong> Sharing personal information without consent</li>
              <li><strong>Copyright Infringement:</strong> Using others' content without permission</li>
              <li><strong>Misinformation:</strong> Deliberately false or misleading information</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Photo & Media Guidelines</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Upload only photos you took or have permission to use</li>
              <li>Ensure photos accurately represent the business</li>
              <li>Don't include faces of people without their consent</li>
              <li>Avoid photos that could be misleading or staged</li>
              <li>Keep photos appropriate for all audiences</li>
              <li>Include helpful captions when relevant</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Language & Tone</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Use language appropriate for a professional environment</li>
              <li>Avoid excessive profanity or offensive language</li>
              <li>Be constructive, even when expressing criticism</li>
              <li>Respect cultural and linguistic diversity</li>
              <li>Use clear, understandable language</li>
              <li>Stay on topic and relevant to the business</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Content Moderation
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Our community reports inappropriate content, and our moderation team reviews flagged items. 
              We may remove content or restrict accounts that violate these standards.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'privacy-safety',
      title: 'Privacy & Safety Guidelines',
      icon: '🛡️',
      color: '#0288d1',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Protecting privacy and ensuring safety is everyone's responsibility in our community:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Protecting Your Privacy</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Review your privacy settings regularly</li>
              <li>Be mindful of what personal information you share publicly</li>
              <li>Don't share sensitive personal details in reviews or comments</li>
              <li>Use privacy controls to limit who can see your activity</li>
              <li>Report privacy violations when you encounter them</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Respecting Others' Privacy</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Don't share photos with identifiable people without permission</li>
              <li>Avoid mentioning specific employee names in negative reviews</li>
              <li>Don't share private conversations or communications</li>
              <li>Respect business confidentiality when appropriate</li>
              <li>Don't doxx or reveal personal information about others</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Safety Best Practices</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Don't share your exact location or home address</li>
              <li>Be cautious about meeting people from the platform in person</li>
              <li>Report threatening or concerning behavior immediately</li>
              <li>Use strong passwords and enable two-factor authentication</li>
              <li>Trust your instincts if something feels unsafe</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Reporting Safety Issues</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Report harassment, threats, or inappropriate behavior</li>
              <li>Flag content that violates privacy or safety guidelines</li>
              <li>Contact us immediately for urgent safety concerns</li>
              <li>Provide detailed information to help our investigation</li>
              <li>Know that reports are taken seriously and investigated promptly</li>
            </ul>
          </div>

          <div style={warningAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Emergency Situations
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              For immediate physical safety concerns or legal emergencies, contact local law enforcement first. 
              Then notify us at emergency@revfer.com so we can assist with platform-related aspects.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'enforcement',
      title: 'Enforcement & Appeals',
      icon: '⚖️',
      color: '#795548',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            How we enforce these guidelines and what happens when violations occur:
          </p>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Violation Reporting</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Use the "Report" button on any problematic content</li>
              <li>Provide specific details about the violation</li>
              <li>Include relevant screenshots or evidence when helpful</li>
              <li>Don't abuse the reporting system for personal disputes</li>
              <li>Follow up if you need to provide additional information</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#7b1fa2' }}>Investigation Process</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>All reports are reviewed by our moderation team</li>
              <li>We investigate violations fairly and objectively</li>
              <li>Users may be contacted for additional information</li>
              <li>Decisions are based on evidence and community guidelines</li>
              <li>We aim to resolve most issues within 48-72 hours</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#f57c00' }}>Enforcement Actions</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Warning:</strong> First-time minor violations</li>
              <li><strong>Content Removal:</strong> Violating posts, reviews, or photos</li>
              <li><strong>Feature Restrictions:</strong> Limited posting, commenting, or AI access</li>
              <li><strong>Temporary Suspension:</strong> Account access suspended for specific periods</li>
              <li><strong>Permanent Ban:</strong> Account permanently closed for severe violations</li>
            </ul>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#388e3c' }}>Appeals Process</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li>Appeal enforcement actions through appeals@revfer.com</li>
              <li>Provide new evidence or clarification about the situation</li>
              <li>Appeals are reviewed by a different team member</li>
              <li>We respond to appeals within 5-7 business days</li>
              <li>Decisions may be upheld, modified, or reversed</li>
            </ul>
          </div>

          <div style={errorAlertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Serious Violations
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Severe violations like harassment, fraud, or legal violations may result in immediate 
              permanent suspension without prior warnings. We may also cooperate with law enforcement when appropriate.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'resources',
      title: 'Resources & Support',
      icon: '🆘',
      color: '#607d8b',
      content: (
        <div>
          <p style={{ marginBottom: '16px' }}>
            Get help, report issues, and find additional resources for community participation:
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
            <div style={{ ...cardStyle, backgroundColor: '#e3f2fd', color: '#1976d2' }}>
              <h4 style={{ marginBottom: '8px' }}>Community Support</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: community@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 24 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For questions about community guidelines and participation.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#fff3e0', color: '#f57c00' }}>
              <h4 style={{ marginBottom: '8px' }}>Report Violations</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: report@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 48 hours
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For reporting guideline violations and inappropriate content.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#ffebee', color: '#d32f2f' }}>
              <h4 style={{ marginBottom: '8px' }}>Safety & Emergencies</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: emergency@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Immediate
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For urgent safety concerns and emergency situations.
              </p>
            </div>
            <div style={{ ...cardStyle, backgroundColor: '#e8f5e8', color: '#388e3c' }}>
              <h4 style={{ marginBottom: '8px' }}>Appeals & Disputes</h4>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Email: appeals@revfer.com
              </p>
              <p style={{ margin: '0 0 8px 0', fontSize: '14px' }}>
                Response time: Within 7 days
              </p>
              <p style={{ margin: 0, fontSize: '14px' }}>
                For appealing enforcement actions and dispute resolution.
              </p>
            </div>
          </div>

          <div style={cardStyle}>
            <h4 style={{ marginBottom: '12px', color: '#1976d2' }}>Additional Resources</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              <li><strong>Help Center:</strong> help.revfer.com - Comprehensive guides and FAQs</li>
              <li><strong>Community Forum:</strong> Discussion space for users to help each other</li>
              <li><strong>Best Practices Guide:</strong> Tips for writing effective reviews</li>
              <li><strong>Business Owner Resources:</strong> Tools and guides for business accounts</li>
              <li><strong>Privacy Center:</strong> Information about privacy controls and data rights</li>
            </ul>
          </div>

          <div style={alertStyle}>
            <h4 style={{ margin: '0 0 8px 0' }}>
              Community Leadership Program
            </h4>
            <p style={{ margin: 0, fontSize: '14px' }}>
              Active community members who consistently follow guidelines may be invited to join our 
              Community Leadership Program, helping moderate content and mentor new users.
            </p>
          </div>
        </div>
      )
    }
  ];

  return (
    <>
      {/* 🚀 COMPREHENSIVE SEO OPTIMIZATION WITH STRUCTURED DATA */}
      <EnhancedSEO 
        title="Community Guidelines - Revfer | Platform Standards & Review Guidelines"
        description="Comprehensive community guidelines for Revfer's AI business discovery platform. Learn platform standards, authentic review guidelines, trust network rules, business interaction policies, content standards, privacy protection, and community enforcement for professional networking and business discovery."
        keywords="community guidelines, platform standards, review guidelines, community rules, authentic reviews, trust network, business interaction guidelines, content standards, platform moderation, community enforcement, professional networking rules, business discovery guidelines, platform safety, user conduct, review platform rules, community standards, platform policies, user guidelines, business review ethics"
        type="webpage"
        image="/images/revfer-community-guidelines-og.jpg"
        author="Revfer Community Team"
        dateModified="2025-06-04T00:00:00Z"
        datePublished="2024-01-15T00:00:00Z"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Legal', url: '/legal' },
          { name: 'Community Guidelines', url: '/legal/community-guidelines' }
        ]}
        organizationData={{
          "@context": "https://schema.org",
          "@type": ["TechnologyCompany", "CommunityGuidelines"],
          "mainEntity": {
            "@type": "CreativeWork",
            "name": "Revfer Community Guidelines",
            "description": "Comprehensive guidelines for authentic reviews, trust networks, business interactions, and community standards on Revfer's AI business discovery platform",
            "url": "https://www.revfer.com/legal/community-guidelines",
            "dateModified": "2025-06-04T00:00:00Z",
            "datePublished": "2024-01-15T00:00:00Z",
            "publisher": {
              "@type": "Organization",
              "name": "Revfer Inc",
              "url": "https://www.revfer.com",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.revfer.com/logo.png"
              }
            },
            "inLanguage": "en-US",
            "copyrightHolder": {
              "@type": "Organization",
              "name": "Revfer Inc"
            },
            "about": [
              {
                "@type": "Thing",
                "name": "Authentic Review Writing",
                "description": "Guidelines for writing honest, helpful business reviews based on real experiences"
              },
              {
                "@type": "Thing",
                "name": "Trust Network Building",
                "description": "Rules for creating and maintaining authentic professional connections"
              },
              {
                "@type": "Thing", 
                "name": "Business Interaction Standards",
                "description": "Guidelines for professional communication between customers and businesses"
              },
              {
                "@type": "Thing",
                "name": "Content & Communication Standards",
                "description": "Platform standards for appropriate, helpful, and respectful content"
              },
              {
                "@type": "Thing",
                "name": "Privacy & Safety Protection",
                "description": "Community guidelines for protecting privacy and ensuring user safety"
              },
              {
                "@type": "Thing",
                "name": "Community Enforcement",
                "description": "How guidelines are enforced and appeals process for community violations"
              }
            ],
            "mentions": [
              {
                "@type": "Thing",
                "name": "Authentic Reviews",
                "description": "Reviews based on genuine personal experiences with businesses"
              },
              {
                "@type": "Thing",
                "name": "Trust Networks",
                "description": "Verified connections and relationships that validate review credibility"
              },
              {
                "@type": "Thing",
                "name": "Community Verification",
                "description": "Collaborative process to verify business information and review authenticity"
              },
              {
                "@type": "Thing",
                "name": "AI-Assisted Content",
                "description": "Guidelines for using AI tools while maintaining authenticity"
              }
            ],
            "communityValues": [
              "Trust & Authenticity",
              "Respect & Kindness", 
              "Helpfulness & Support",
              "Constructive Engagement",
              "Privacy Protection",
              "Professional Communication"
            ],
            "prohibitedContent": [
              "Fake or fraudulent reviews",
              "Review manipulation schemes",
              "Harassment and bullying",
              "Hate speech and discrimination",
              "Privacy violations",
              "Spam and irrelevant content",
              "Misinformation and false claims"
            ],
            "encouragedBehavior": [
              "Detailed, helpful reviews",
              "Professional business interactions",
              "Authentic trust network building",
              "Constructive feedback and criticism",
              "Community verification participation",
              "Respectful communication"
            ]
          },
          "name": "Revfer",
          "alternateName": "Revfer Inc",
          "description": "AI business discovery platform with comprehensive community standards and authentic review guidelines",
          "url": "https://www.revfer.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.revfer.com/logo.png",
            "caption": "Revfer AI Platform Logo"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "59 Grover Rd",
            "addressLocality": "Ashland",
            "addressRegion": "MA",
            "postalCode": "01721",
            "addressCountry": "US"
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "contactType": "community support",
              "email": "community@revfer.com",
              "availableLanguage": "English",
              "description": "Questions about community guidelines and participation"
            },
            {
              "@type": "ContactPoint",
              "contactType": "violation reporting",
              "email": "report@revfer.com", 
              "availableLanguage": "English",
              "description": "Report guideline violations and inappropriate content"
            },
            {
              "@type": "ContactPoint",
              "contactType": "emergency support",
              "email": "emergency@revfer.com",
              "availableLanguage": "English",
              "description": "Urgent safety concerns and emergency situations"
            },
            {
              "@type": "ContactPoint",
              "contactType": "appeals",
              "email": "appeals@revfer.com",
              "availableLanguage": "English", 
              "description": "Appeal enforcement actions and dispute resolution"
            }
          ],
          "sameAs": [
            "https://twitter.com/revfer",
            "https://linkedin.com/company/revfer"
          ],
          "knowsAbout": [
            "Community Guidelines",
            "Review Authenticity",
            "Trust Networks",
            "Business Review Ethics",
            "Platform Moderation",
            "User Safety",
            "Professional Networking Standards",
            "Content Moderation",
            "Community Enforcement",
            "Business Interaction Guidelines"
          ],
          "communityGuidelines": "https://www.revfer.com/legal/community-guidelines",
          "termsOfService": "https://www.revfer.com/legal/terms-of-service",
          "privacyPolicy": "https://www.revfer.com/legal/privacy-policy",
          "moderationPolicy": [
            {
              "@type": "Thing",
              "name": "Content Review Process",
              "description": "How reported content is reviewed and moderated by community team"
            },
            {
              "@type": "Thing",
              "name": "Enforcement Actions",
              "description": "Range of actions from warnings to permanent account suspension"
            },
            {
              "@type": "Thing", 
              "name": "Appeals Process",
              "description": "How users can appeal moderation decisions and enforcement actions"
            },
            {
              "@type": "Thing",
              "name": "Community Reporting",
              "description": "How community members can report violations and inappropriate content"
            }
          ],
          "safetyMeasures": [
            {
              "@type": "Thing",
              "name": "Privacy Protection",
              "description": "Guidelines to protect personal information and user privacy"
            },
            {
              "@type": "Thing",
              "name": "Harassment Prevention", 
              "description": "Measures to prevent and address harassment and bullying"
            },
            {
              "@type": "Thing",
              "name": "Trust Verification",
              "description": "Systems to verify authentic reviews and connections"
            },
            {
              "@type": "Thing",
              "name": "Emergency Response",
              "description": "Procedures for handling urgent safety and security concerns"
            }
          ]
        }}
        faqData={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What makes a good review on Revfer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "A good review is based on your personal experience, includes specific details about products or services, provides balanced perspective with both positives and areas for improvement, uses respectful language, and offers helpful context for other potential customers."
              }
            },
            {
              "@type": "Question",
              "name": "Can I use AI to help write my reviews?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, you can use AI assistance to help articulate your thoughts more clearly. However, you must review and edit AI-generated content before publishing, ensure it accurately reflects your personal experience, and never use AI to fabricate experiences you didn't have."
              }
            },
            {
              "@type": "Question",
              "name": "What happens if I violate community guidelines?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Violations may result in warnings, content removal, feature restrictions, temporary suspension, or permanent account closure depending on severity. You can appeal enforcement actions through appeals@revfer.com. We aim for fair, objective enforcement based on evidence."
              }
            },
            {
              "@type": "Question",
              "name": "How do I report inappropriate content or behavior?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Use the 'Report' button on any problematic content, or email report@revfer.com with specific details about the violation. Include screenshots or evidence when helpful. All reports are reviewed by our moderation team within 48-72 hours."
              }
            },
            {
              "@type": "Question",
              "name": "What are trust networks and how do they work?",
              "acceptedAnswer": {
                "@type": "Answer", 
                "text": "Trust networks are verified connections with people you know personally or professionally. They help validate review credibility and build community trust. Connect with real relationships, participate honestly in verification activities, and help maintain network integrity."
              }
            },
            {
              "@type": "Question",
              "name": "Can businesses respond to reviews on Revfer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, businesses can respond professionally to reviews. They should address concerns constructively, thank customers for feedback, and maintain respectful communication. Businesses cannot ask customers to remove reviews or offer incentives for positive reviews."
              }
            }
          ]
        }}
      />

      <div style={containerStyle}>
        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
            <span style={{ fontSize: '40px', marginRight: '16px' }}>🌟</span>
            <h1 style={{ margin: 0, fontSize: '48px', fontWeight: '300' }}>
              Community Guidelines
            </h1>
          </div>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '400', opacity: 0.9 }}>
            Building a trusted community through authentic reviews and meaningful connections.
          </h2>
          <div style={{ 
            display: 'inline-block', 
            marginTop: '16px',
            padding: '8px 16px',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: '16px',
            fontSize: '14px'
          }}>
            Updated: June 4, 2025
          </div>
        </div>

        {/* Quick Navigation */}
        <div style={paperStyle}>
          <h3 style={{ marginBottom: '16px', color: '#388e3c' }}>
            Quick Navigation
          </h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {sections.map((section) => (
              <span
                key={section.id}
                style={{
                  ...chipStyle,
                  backgroundColor: expandedSection === section.id ? section.color : '#f5f5f5',
                  color: expandedSection === section.id ? 'white' : '#666',
                  border: expandedSection === section.id ? 'none' : '1px solid #e0e0e0'
                }}
                onClick={() => setExpandedSection(section.id)}
              >
                {section.icon} {section.title}
              </span>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div>
          {sections.map((section) => (
            <div key={section.id} style={accordionStyle}>
              <div
                style={{
                  ...accordionHeaderStyle,
                  backgroundColor: expandedSection === section.id ? '#f5f5f5' : '#fafafa'
                }}
                onClick={() => handleAccordionToggle(section.id)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: '24px', marginRight: '12px', color: section.color }}>
                    {section.icon}
                  </span>
                  <h3 style={{ margin: 0, fontSize: '20px' }}>
                    {section.title}
                  </h3>
                </div>
                <span style={{ fontSize: '20px', color: '#666' }}>
                  {expandedSection === section.id ? '−' : '+'}
                </span>
              </div>
              {expandedSection === section.id && (
                <div style={accordionContentStyle}>
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Footer Actions */}
        {showSection && 
         <div style={{ ...paperStyle, backgroundColor: '#f5f5f5', marginTop: '32px' }}>
         <h3 style={{ marginBottom: '16px', color: '#388e3c' }}>
           Join Our Community
         </h3>
         <p style={{ marginBottom: '16px' }}>
           Ready to start contributing? Follow these guidelines to help build the most trusted 
           business discovery platform.
         </p>
         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
           <button 
             style={primaryButtonStyle}
             onClick={() => window.location.href = '/find'}
           >
             Start Writing Reviews
           </button>
           <button 
             style={outlinedButtonStyle}
             onClick={() => window.location.href = 'mailto:report@revfer.com?subject=Community Guidelines Violation Report'}
           >
             Report an Issue
           </button>
           <button 
             style={outlinedButtonStyle}
             onClick={() => window.location.href = 'mailto:community@revfer.com?subject=Community Guidelines Question'}
           >
             Contact Community Team
           </button>
         </div>
       </div>
        }
       
      </div>
    </>
  );
};

export default CommunityGuidelinesPage;